import React from 'react'
import { TooltipRenderProps } from 'react-joyride'

import { IOnboardingJoyrideStep, ONBOARDING_JOYRIDE_STEP_TYPE } from '../onboardingJoyride.types'

import { GeneralJoyrideTooltip } from './GeneralJoyrideTooltip'
import { TargetJoyrideTooltip } from './TargetJoyrideTooltip'

export interface IBaseJoyrideTooltipProps extends Omit<TooltipRenderProps, 'step'> {
  step: IOnboardingJoyrideStep
}

export function BaseJoyrideTooltip({ step, ...props }: IBaseJoyrideTooltipProps) {
  if ('type' in step) {
    return (
      <div {...props} {...props.tooltipProps}>
        {(() => {
          switch (step.type) {
            case ONBOARDING_JOYRIDE_STEP_TYPE.GENERAL:
              return <GeneralJoyrideTooltip step={step} {...props} />
            case ONBOARDING_JOYRIDE_STEP_TYPE.TARGET:
            default:
              return <TargetJoyrideTooltip step={step} {...props} />
          }
        })()}
      </div>
    )
  }

  return <TargetJoyrideTooltip step={step} {...props} />
}
